@if(storeStatus()?.isOpen && !storeStatus()?.isClosedForVacation){
  <cwo-hourglass />
} @else {
  <img src="../../../assets/icons/closed_tag.png" class="image" [alt]="'Closed Store Image'"/>
}

<span class="title">{{ storeStatus()?.statusMessage }}</span>
